import { injectable } from 'inversify';
import ToastData from '../../../@resources/texts/toast.json';
import { LibraryBase } from '../../canvas/LibraryBase';
import { Connector } from '../../Container';
import { ToastDefinition } from './ToastDefinition';

@injectable()
export class ToastLibrary extends LibraryBase<ToastDefinition> {

    constructor() {
        super();
        (ToastData as ToastDefinition[]).forEach(x => this.register(x));
    }

    protected index = item => item.name;
}

export const inToast = (...defs: ToastDefinition[]): Connector =>
    r => void (defs.forEach(t => r.call(ToastLibrary).register(t)));
